import { useSeo } from '../lib/seo';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';

export default function TownsPage() {
  useSeo(
    "Visit Leicestershire's Market Towns — Melton Mowbray, Market Harborough & More | GoLeicestershire",
    "Visit Leicestershire's market towns — Melton Mowbray, Market Harborough, Loughborough, Hinckley, Ashby and more — with local guides to food, shopping and days out."
  );
  const [data, setData] = useState({ items: [] });
  useEffect(() => { api.get('/towns').then((r) => setData(r.data)); }, []);
  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16">
      <div className="label text-heritage mb-3">Market towns</div>
      <h1 className="font-display text-5xl lg:text-7xl leading-[0.95] mb-12">Nine towns. <em className="not-italic text-heritage">Countless villages.</em></h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {data.items.map((t, i) => (
          <Link key={t.id} to={`/towns/${t.slug}`} data-testid={`towns-page-card-${t.slug}`} className={`group relative ${i % 3 === 0 ? 'md:col-span-2 aspect-[16/9]' : 'aspect-[4/5]'} rounded-3xl overflow-hidden block`}>
            <img src={t.hero_image} alt={t.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8 lg:p-12 text-base">
              <div className="label text-mustard mb-2">Discover</div>
              <h2 className={`font-display leading-tight ${t.name.length > 24 ? 'text-2xl sm:text-3xl lg:text-4xl' : 'text-4xl lg:text-5xl'}`}>{t.name}</h2>
              {t.summary && <p className="mt-3 text-base/85 max-w-xl text-sm sm:text-lg line-clamp-3 sm:line-clamp-4">{t.summary}</p>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
